// Copyright (c) 2017 Deere & Company

import actions from '../actions-list';

export const selectAllOpenPipsDealers = dealers => ({
    dealers,
    type: actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS
});

export const selectOpenPipsReportDealer = (dealer, isSelected) => ({
    dealer,
    isSelected,
    type: actions.UPDATE_OPEN_PIP_PROGRAMS_REPORT_DEALER_SELECTION
});

export const selectAllDealersOnLoad = dealers => ({
    dealers,
    type: actions.SELECT_ALL_OPEN_PIP_PROGRAMS_REPORT_DEALERS_ON_LOAD
});



// WEBPACK FOOTER //
// ./src/reports/open-pip-programs/action-creators/select-dealer.js